"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPOS_CLEARING_TX_STATUSES = exports.OposStatusEnum = void 0;
const transactionStatus_enum_1 = require("../transaction/transactionStatus.enum");
/** Display labels for an OPOS row in the UI; derived from `invoiceDueDate`, not persisted. */
var OposStatusEnum;
(function (OposStatusEnum) {
    /** Due date >= today (or unset) */
    OposStatusEnum["OPEN"] = "OPEN";
    /** Due date < today (overdue) */
    OposStatusEnum["DUE"] = "DUE";
})(OposStatusEnum || (exports.OposStatusEnum = OposStatusEnum = {}));
exports.OPOS_CLEARING_TX_STATUSES = [transactionStatus_enum_1.TransactionStatusEnum.COMPLETED];
